export interface ShiftRosterEntryInput {
    readonly shiftDate: string;
    readonly userId: string;
    readonly role: string;
}

/**
 * Replace-the-set payload: after saving, the roster for the shift over `[from, to]` contains exactly
 * `entries`. An empty list clears the range.
 */
export interface ShiftRosterReplaceModel {
    readonly shiftId: number;
    readonly from: string;
    readonly to: string;
    readonly entries: readonly ShiftRosterEntryInput[];
}
